/** Preflight classification of a FEC third party against the contacts already in Billy (ADVP-629). */
export enum FecThirdPartyCategory {
  Blocked = 'blocked',
  Create = 'create',
  Reuse = 'reuse',
  SimilarName = 'similarName',
}
